import { render, staticRenderFns } from "./LookbookCardLink.vue?vue&type=template&id=a50b6ddc&"
import script from "./LookbookCardLink.vue?vue&type=script&lang=js&"
export * from "./LookbookCardLink.vue?vue&type=script&lang=js&"
import style0 from "./LookbookCardLink.vue?vue&type=style&index=0&id=a50b6ddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardDefaultMultiple: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardDefaultMultiple.vue').default})
